import { get } from 'lodash';
import { ANTRAGS_FORMULAREN } from '../../../../../lib/constants/constant';
import { TreeNodeType } from '../../../../../lib/types/types';
import { assignIdsToStruc, groupKostenByPosition } from '../../../../../utils/helper';
import { TreeStructureSkizzeEmob } from './emob/TreeStructureSkizzeEmob';
import { TreeStructureSkizzeLoewe } from './loewe/TreeStructureSkizzeLoewe';
import { TreeStructureSkizzeLogMob } from './logmob/TreeStructureSkizzeLogMob';
import { TreeStructureSkizzeStipendium } from './stipendium/TreeStructureSkizzeStipendium';

// import schemas
import Schema from '../../../../../lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

export const TreeStructureSkizze = (
	application: any,
	kostenKategories: any,
	allgemeineHinweiseKMU: any,
	allgemeineHinweiseDeminimis: any,
	allgemeineHinweiseRUS: any,
	allgemeineHinweiseBeihilferelevanz: any,
	readOnly: boolean,
) => {
	let treeNodes: TreeNodeType[] = [];
	const kostenKategoriesGroup = groupKostenByPosition(kostenKategories);
	const antragsFormular = get(application, P.Allgemein_Antragsformular.path, '');

	switch (antragsFormular) {
		case ANTRAGS_FORMULAREN.EmobFundE:
			treeNodes = TreeStructureSkizzeEmob(
				application,
				kostenKategoriesGroup,
				readOnly,
				allgemeineHinweiseKMU,
				allgemeineHinweiseDeminimis,
				allgemeineHinweiseRUS,
				allgemeineHinweiseBeihilferelevanz,
			);
			break;
		case ANTRAGS_FORMULAREN.Loewe:
			treeNodes = TreeStructureSkizzeLoewe(
				application,
				kostenKategoriesGroup,
				readOnly,
				allgemeineHinweiseKMU,
				allgemeineHinweiseDeminimis,
				allgemeineHinweiseRUS,
				allgemeineHinweiseBeihilferelevanz,
			);
			break;
		case ANTRAGS_FORMULAREN.LogistikUndMobilitaet:
			treeNodes = TreeStructureSkizzeLogMob(application, readOnly, allgemeineHinweiseKMU, allgemeineHinweiseDeminimis, allgemeineHinweiseRUS, allgemeineHinweiseBeihilferelevanz);
			break;
		case ANTRAGS_FORMULAREN.StartUpStipendium:
			treeNodes = TreeStructureSkizzeStipendium(application, readOnly);
			break;
		default:
			treeNodes = [];
	}
	return assignIdsToStruc(treeNodes);
};
